import { render, staticRenderFns } from "./OldAchieveEdit.vue?vue&type=template&id=6a22b9dd"
import script from "./OldAchieveEdit.vue?vue&type=script&lang=js"
export * from "./OldAchieveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports